import { IconButton } from '@material-ui/core'
import { Dropdown } from '../../../../../Dropdown'
import { Icon } from '../../../../../Icon'
import { useTranslation } from 'react-i18next'

import * as S from './styles'
import { THEMES_NAME } from 'config/theme.config'
import { theme } from 'config'

type IndustryGroupFilterDropDownProps = {
  setDeleteIndustry?: () => void
}

export const IndustryGroupFilterDropDown = ({
  setDeleteIndustry
}: IndustryGroupFilterDropDownProps) => {
  const { t } = useTranslation()
  return (
    <S.Wrapper>
      <Dropdown
        title={
          <IconButton
            id="action"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {}}
            size="medium"
            edge="start"
          >
            <Icon
              icon={
                theme.appTheme === THEMES_NAME.swift
                  ? 'itens-interface-actions-swift'
                  : 'itens-interface-actions'
              }
              width={12}
              height={12}
              aria-label="action"
            />
          </IconButton>
        }
      >
        <S.Nav>
          <S.Link onClick={setDeleteIndustry}>
            <Icon icon="dropdown-delete" height={16} width={16} />
            <span>{t('common:oneIndustryRemove')}</span>
          </S.Link>
        </S.Nav>
      </Dropdown>
    </S.Wrapper>
  )
}
